import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, useMap, GeoJSON, Popup, Polygon, SVGOverlay } from 'react-leaflet';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import LoadingBox from "components/LoadingBox";
import parse from 'html-react-parser';
import "assets/css/map.css";
import L from 'leaflet'
import MapaLeafletRota from 'components/Map/MapaLeafletRota';

export default function MapaPolyInfoLeaflet(props) {
    const {
        showLoading,
        centerMap,
        zoomMap,
        polygons
    } = props;

    const ChangeMap = ({ center, zoom }) => {
        const mapInstance = useMap();
        mapInstance.setView(center, zoom);
        return null;
    }

    return (
        <>
            <div id="map">
                <div className="useloading">
                    <MapContainer style={{ zIndex: "0", height: "90vh" }}>
                        <ChangeMap center={centerMap} zoom={zoomMap}></ChangeMap>
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            opacity={0.2}
                        />
                        {polygons && polygons.map((m) => {
                            return <SVGOverlay key={m.key} bounds={JSON.parse(m.polygon)}>
                                        <Polygon positions={JSON.parse(m.polygon)} color={m.backgroundColor}>
                                            {m.detailPopup && <Popup><div style={{ width: "280px", backgroundColor: "#fff", height: "350px", overflow: "auto" }}>{parse(m.detailPopup)}</div></Popup>}
                                        </Polygon>
                                        <text x="40%" y={"50%"}>{m.label}</text>
                                    </SVGOverlay>
                        })}
                        {showLoading && <LoadingBox />}
                    </MapContainer>
                </div>
            </div>

        </>
    )
}